import React from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import TabNavigation from 'src/components/sticky-tab-nav';

import { MAX_RESULTS } from '../../constants';

import { TabAnchor } from './types';

type Props = {
  activeTab: string;
  brandsCount: number;
  categoriesCount: number;
  productsCount: number;
  storesCount: number;
  onClick: (tab: string) => void;
};

export const SearchResultsNavigation = (props: Props) => {
  const { market, t } = useAppContext();

  const {
    activeTab,
    brandsCount,
    categoriesCount,
    productsCount,
    storesCount,
    onClick,
  } = props;

  const formattedProductsCount =
    (productsCount || 0) >= MAX_RESULTS
      ? `${MAX_RESULTS.toLocaleString(market.localeStandard)}+`
      : (productsCount || 0).toLocaleString(market.localeStandard);

  return (
    <TabNavigation
      defaultActiveTabId={activeTab || TabAnchor.ALL}
      tabs={[
        ...[
          {
            id: TabAnchor.ALL,
            title: t('search', 'search.see-all-tab'),
          },
        ],
        ...(productsCount
          ? [
              {
                id: TabAnchor.PRODUCTS,
                title: `${t(
                  'search',
                  'products.title'
                )} (${formattedProductsCount})`,
              },
            ]
          : []),
        ...(categoriesCount
          ? [
              {
                id: TabAnchor.CATEGORIES,
                title: `${t(
                  'search',
                  'categories.title'
                )} (${categoriesCount.toLocaleString(market.localeStandard)})`,
              },
            ]
          : []),
        ...(brandsCount
          ? [
              {
                id: TabAnchor.BRANDS,
                title: `${t(
                  'search',
                  'brands.title'
                )} (${brandsCount.toLocaleString(market.localeStandard)})`,
              },
            ]
          : []),
        ...(storesCount
          ? [
              {
                id: TabAnchor.STORES,
                title: `${t(
                  'search',
                  'stores.title'
                )} (${storesCount.toLocaleString(market.localeStandard)})`,
              },
            ]
          : []),
      ]}
      onClick={onClick}
    />
  );
};
